import { replace, getOne, create, deleteOne } from '../modules/fetch';
import {
  Panel,
  panelSchema,
  PANEL_ENTITY_NAME,
  PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME,
  panelSubscriptionSettingsSchema,
  PanelSubscriptionSettings,
} from './definitions';

interface SetCurrentPanelAction {
  type: 'ORG.SET_CURRENT_PANEL';
  payload: string;
}

interface SetCurrentPanelOrganizationAction {
  type: 'ORG.SET_CURRENT_ORGANIZATION';
  payload: string;
}

export type OrganizationAction =
  | SetCurrentPanelAction
  | SetCurrentPanelOrganizationAction;

export const setCurrentOrganization = (
  organizationId: string,
): SetCurrentPanelOrganizationAction => ({
  type: 'ORG.SET_CURRENT_ORGANIZATION',
  payload: organizationId,
});

export const setCurrentPanelId = (panelId: string): SetCurrentPanelAction => ({
  type: 'ORG.SET_CURRENT_PANEL',
  payload: panelId,
});

export const getPanel = (id: string) =>
  getOne<Panel>({
    id,
    entity: PANEL_ENTITY_NAME,
    schema: panelSchema,
  });

export const updatePanel = (id: string, values: Partial<Panel>) =>
  replace<Panel>({
    id,
    payload: values,
    entity: PANEL_ENTITY_NAME,
    schema: panelSchema,
  });

export const createPanel = (values: Partial<Panel>) =>
  create<Panel>({
    payload: values,
    entity: PANEL_ENTITY_NAME,
    schema: panelSchema,
  });

export const deletePanel = (panelId: string) =>
  deleteOne<Panel>({
    entity: PANEL_ENTITY_NAME,
    schema: panelSchema,
    id: panelId,
  });

export const getSubscriptionFormSettings = (id: string) =>
  getOne<PanelSubscriptionSettings>({
    id,
    entity: PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME,
    schema: panelSubscriptionSettingsSchema,
  });

export const updateSubscriptionFormSettings = (
  id: string,
  values: Partial<PanelSubscriptionSettings>,
) =>
  replace<PanelSubscriptionSettings>({
    id,
    payload: values,
    entity: PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME,
    schema: panelSubscriptionSettingsSchema,
  });
